// Shared visual metadata for the four delivery types across the Ops dashboard.
export const DELIVERY_TYPE_META = {
  private_delivery: { label: 'Private', color: '#3B82F6', bg: 'bg-blue-50', text: 'text-blue-700', ring: 'ring-blue-200' },
  partner_conferences: { label: 'Conference', color: '#8B5CF6', bg: 'bg-violet-50', text: 'text-violet-700', ring: 'ring-violet-200' },
  regional_in_person: { label: 'RIO', color: '#10B981', bg: 'bg-emerald-50', text: 'text-emerald-700', ring: 'ring-emerald-200' },
  pprw: { label: 'PPRW', color: '#F59E0B', bg: 'bg-amber-50', text: 'text-amber-700', ring: 'ring-amber-200' },
};

export const typeMeta = (t) => DELIVERY_TYPE_META[t] || { label: t, color: '#6B7280', bg: 'bg-gray-50', text: 'text-gray-700', ring: 'ring-gray-200' };

export const fmtDate = (iso) => {
  if (!iso) return '—';
  return new Date(iso + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
